document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav drawer
  var openBtn = document.querySelector('[data-mobile-nav-open]');
  var closeBtn = document.querySelector('[data-mobile-nav-close]');
  var drawer = document.getElementById('MobileNavDrawer');
  var overlay = document.getElementById('MobileNavOverlay');

  function openNav() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  // Predictive search panel toggle
  var searchOpenBtn = document.querySelector('[data-search-open]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  var searchPanel = document.getElementById('HeaderSearchPanel');
  if (searchOpenBtn && searchPanel) {
    searchOpenBtn.addEventListener('click', function () {
      searchPanel.classList.toggle('hidden');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input && !searchPanel.classList.contains('hidden')) input.focus();
    });
  }
  if (searchCloseBtn && searchPanel) {
    searchCloseBtn.addEventListener('click', function () {
      searchPanel.classList.add('hidden');
    });
  }

  // Hero slideshow (simple auto + manual controls, section-scoped)
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (slides.length < 2) return;
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) {
        s.classList.toggle('hidden', si !== index);
      });
      dots.forEach(function (d, di) {
        d.classList.toggle('text-white', di === index);
        d.classList.toggle('border-brand-lime', di === index);
        d.classList.toggle('text-gray-500', di !== index);
      });
    }
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { show(di); });
    });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    if (autoplay) {
      setInterval(function () { show(index + 1); }, 6000);
    }
    show(0);
  });
});
